// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"Icons_iconsWrapper__sjPbm","icon":"Icons_icon__6DyWt"};